export type PriceDisplayMode = 'striked' | 'with-end-date' | 'simple';

export const PRICE_DISPLAY_MODES: readonly PriceDisplayMode[] = [
  'striked',
  'with-end-date',
  'simple',
] as const;

export type ModuleKey = 'tables' | 'vehicles' | 'rooms';

export const MODULE_KEYS: readonly ModuleKey[] = ['tables', 'vehicles', 'rooms'] as const;

export interface EnabledModules {
  tables: boolean;
  vehicles: boolean;
  rooms: boolean;
}

export const DEFAULT_ENABLED_MODULES: EnabledModules = {
  tables: true,
  vehicles: true,
  rooms: true,
};

export interface UiSettings {
  priceDisplayMode: PriceDisplayMode;
  enabledModules: EnabledModules;
}

export const DEFAULT_UI_SETTINGS: UiSettings = {
  priceDisplayMode: 'striked',
  enabledModules: DEFAULT_ENABLED_MODULES,
};

export function isPriceDisplayMode(value: unknown): value is PriceDisplayMode {
  return typeof value === 'string' && (PRICE_DISPLAY_MODES as readonly string[]).includes(value);
}

export function firstEnabledModule(s: UiSettings): ModuleKey | null {
  for (const k of MODULE_KEYS) if (s.enabledModules[k]) return k;
  return null;
}

export function isEnabledModules(value: unknown): value is EnabledModules {
  if (!value || typeof value !== 'object') return false;
  const v = value as any;
  return typeof v.tables === 'boolean' && typeof v.vehicles === 'boolean' && typeof v.rooms === 'boolean';
}
